var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoneyPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 392,
    viewBox: "0 0 407 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.607 172.969L114.857 171.959L113.107 172.969L24.0302 224.397L22.2802 225.408V227.429V330.286V332.306L24.0302 333.317L113.107 384.745L114.857 385.756L116.607 384.745L205.684 333.317L207.434 332.306V330.286V227.429V225.408L205.684 224.397L116.607 172.969Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.607 174.969L295.857 173.959L294.107 174.969L205.03 226.397L203.28 227.408V229.429V332.286V334.306L205.03 335.317L294.107 386.745L295.857 387.756L297.607 386.745L386.684 335.317L388.434 334.306V332.286V229.429V227.408L386.684 226.397L297.607 174.969Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.607 15.9689L203.857 14.9585L202.107 15.9689L113.03 67.3974L111.28 68.4078V70.4285V173.286V175.306L113.03 176.317L202.107 227.745L203.857 228.756L205.607 227.745L294.684 176.317L296.434 175.306V173.286V70.4285V68.4078L294.684 67.3974L205.607 15.9689Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneyPoints);
export default __webpack_public_path__ + "static/media/honeyPoints.ce2b6c593f178d27dab912fd2e43dac4.svg";
export { ForwardRef as ReactComponent };